// extracted by mini-css-extract-plugin
export default {"contatoPage":"Contato_contatoPage__W-28Q","contatoDiv":"Contato_contatoDiv__QJJP7","formContato":"Contato_formContato__dPwnR","pessoaInfo":"Contato_pessoaInfo__WsiRg"};